import styled from 'styled-components';

const HeroStyle = styled.div`
	--heroSVGDistance: var(--sp6x);
	--svgSize: var(--sp30x);
	--heroDescMTop: var(--sp6x);

	.hero-svg-block {
		display: flex;
		justify-content: center;
		margin-bottom: var(--heroSVGDistance);
	}

	canvas {
		width: var(--svgSize) !important;
		height: var(--svgSize) !important;
	}

	@keyframes opacity {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}

	.hero-description {
		margin-top: var(--heroDescMTop);
		opacity: 0;
		animation: opacity 600ms 450ms ease-in forwards;
		max-width: 70%;
	}

	.hero-top-inner-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.wrapper-title {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--heroSVGDistance: var(--sp5x);
		--svgSize: var(--sp25x);
		--heroDescMTop: var(--sp5x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--heroSVGDistance: var(--sp4x);
		--svgSize: var(--sp20x);
		--heroDescMTop: var(--sp4x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--heroSVGDistance: var(--sp3x);
		--svgSize: var(--sp15x);
		--heroDescMTop: var(--sp3x);

		.hero-description {
			max-width: 100%;
		}
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--heroSVGDistance: var(--sp3x);
		--svgSize: var(--sp15x);
		--heroDescMTop: var(--sp3x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--heroSVGDistance: var(--sp2x);
		--svgSize: var(--sp13x);
		--heroDescMTop: var(--sp2x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--heroSVGDistance: var(--sp2x);
		--svgSize: var(--sp13x);
		--heroDescMTop: var(--sp2x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--heroSVGDistance: var(--sp2x);
		--svgSize: var(--sp11x);
		--heroDescMTop: var(--sp2x);
	}
`;

export default HeroStyle;
